import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createBusinessCompanySaleReportSlice = (set, get) => ({
    businessCompanySaleReport: {
        loading: false,
        data: [],
    },
    getBusinessCompanySaleReport: async (params) => {
        const { param } = params;
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ businessCompanySaleReport: { ...state.businessCompanySaleReport, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: `/v1/business/company-sale-report/${param.FromDate}/${param.ToDate}/${param.CompanyId}/${param.BranchId}`,
                headers: { token }
            });
            set(state => ({ businessCompanySaleReport: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ businessCompanySaleReport: { ...state.businessCompanySaleReport, loading: false } }));
        }
    }
});